import { graphql } from 'app/generated/gql'

/**
 * The practice's live treatment records.
 *
 * This document uses the generated graphql() tag so codegen validates the
 * fields against the current schema.
 *
 * The drawer's Treatment Plans tab used to read `treatmentPlans`, which is
 * Sikka-era data that stopped being written on 2024-11-13 and whose patient ids
 * are the old `D45287-1-*` format. Against today's `K-*` ids it matched nothing,
 * which is why the tab was empty for every patient rather than broken.
 */
export const CONTACT_PROCEDURES_QUERY = graphql(`
  query ContactTreatmentProcedures($search: String, $pagination: PaginationInput) {
    procedures(search: $search, pagination: $pagination) {
      hits {
        id
        patientId
        procedureCode
        description
        tooth
        state
        feeAmount
        appointmentIds
        planIds
        procedureCreateDate
        priority
      }
      total
    }
  }
`)

/**
 * The plans those procedures sit on, for what they settle: whether a procedure
 * is on a plan at all, and whether the practice has already closed the plan.
 * Around one in seven reads "Inactive Treatment Plan" or "Rejected", and that
 * money is shown but never chased.
 */
export const CONTACT_TREATMENT_PLANS_QUERY = graphql(`
  query ContactKollaTreatmentPlans($search: String, $pagination: PaginationInput) {
    treatmentPlans(search: $search, pagination: $pagination) {
      hits {
        id
        patientId
        displayName
        state
        status
        planCreateDate
        procedureIds
      }
      total
    }
  }
`)
